<div class="order-chat" [class.order-chat--admin]="isAdminView">
  <div class="order-chat__header">
    <div class="order-chat__title">
      <i class="bi bi-chat-dots-fill"></i>
      <div>
        <div class="order-chat__title-main">
          {{ peerTitle || 'Order conversation' }}
        </div>
        <div class="order-chat__title-sub">
          Customer ↔ Provider
          <span *ngIf="isClosed"> · Closed</span>
          <span *ngIf="!isClosed && orderStatus"> · {{ orderStatus | titlecase }}</span>
        </div>
      </div>
    </div>

    <div class="order-chat__parties">
      <button
        type="button"
        class="party party--customer"
        [class.party--clickable]="isAdminView"
        (click)="openParticipant('customer')"
        [disabled]="!customerId && !meta?.customerId"
      >
        <app-user-avatar
          [src]="customerBrief?.imageUrl"
          [name]="displayCustomerName"
          [size]="36"
        ></app-user-avatar>
        <span class="party__meta">
          <span class="party__role">Customer</span>
          <span class="party__name">{{ displayCustomerName }}</span>
        </span>
      </button>

      <button
        type="button"
        class="party party--provider"
        [class.party--clickable]="isAdminView"
        (click)="openParticipant('provider')"
        [disabled]="!providerId && !meta?.providerId"
      >
        <app-user-avatar
          [src]="providerBrief?.imageUrl"
          [name]="displayProviderName"
          [size]="36"
        ></app-user-avatar>
        <span class="party__meta">
          <span class="party__role">Provider</span>
          <span class="party__name">{{ displayProviderName }}</span>
        </span>
      </button>
    </div>

    <p class="order-chat__hint" *ngIf="isAdminView">
      Click a name to inspect account details (UID, contact, profile).
    </p>
  </div>

  <div class="order-chat__closed" *ngIf="isClosed">
    Chat is closed for this order.
  </div>

  <div class="order-chat__error" *ngIf="error">{{ error }}</div>

  <div #scrollBox class="order-chat__messages">
    <div class="order-chat__empty" *ngIf="loading">Loading conversation…</div>
    <div class="order-chat__empty" *ngIf="!loading && !messages.length && !error">
      No messages yet between customer and provider.
    </div>

    <div
      class="order-chat__row"
      *ngFor="let m of messages"
      [class.row-customer]="bubbleSide(m) === 'customer'"
      [class.row-provider]="bubbleSide(m) === 'provider'"
      [class.row-other]="bubbleSide(m) === 'other'"
    >
      <div class="order-chat__bubble" [class.mine]="isMine(m)">
        <div class="order-chat__meta">
          <button
            type="button"
            class="name"
            [class.name--link]="isAdminView"
            (click)="openMessageSender(m)"
            [disabled]="!isAdminView"
          >
            {{ displayName(m) }}
          </button>
          <span class="badge">{{ roleBadge(m) }}</span>
          <span class="time">{{ formatTime(m.createdAt) }}</span>
        </div>
        <div class="order-chat__text">{{ m.text }}</div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="inspectVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '92vw', maxWidth: '28rem' }"
  styleClass="order-chat-inspect-dialog"
  header="User details"
>
  <div class="inspect" *ngIf="inspectLoading && !inspectBrief">Loading…</div>
  <div class="inspect" *ngIf="inspectBrief as u">
    <div class="inspect__top">
      <app-user-avatar [src]="u.imageUrl" [name]="u.name" [size]="64"></app-user-avatar>
      <div>
        <div class="inspect__name">{{ u.name }}</div>
        <div class="inspect__role">{{ u.roleLabel }}</div>
      </div>
    </div>

    <div class="inspect__row">
      <span class="label">Email</span>
      <span class="value">{{ u.email || '—' }}</span>
    </div>
    <div class="inspect__row">
      <span class="label">Phone</span>
      <span class="value">
        <a *ngIf="u.phone" [href]="'tel:' + u.phone">{{ u.phone }}</a>
        <ng-container *ngIf="!u.phone">—</ng-container>
      </span>
    </div>
    <div class="inspect__row inspect__row--uid">
      <span class="label">User UID</span>
      <code class="value">{{ u.uid }}</code>
      <button type="button" class="btn-copy" (click)="copyUid()">
        {{ copyHint || 'Copy' }}
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Close"
      class="p-button-text"
      (click)="inspectVisible = false"
    ></button>
    <button
      pButton
      type="button"
      label="Open full profile"
      icon="pi pi-external-link"
      class="p-button-sm"
      [disabled]="!inspectBrief"
      (click)="openFullProfile()"
    ></button>
  </ng-template>
</p-dialog>
